import React from 'react'
import styled from 'styled-components'
import DownloadIcon from '@8x8/oxygen-icon/novo/DownloadIcon'

import { secondaryInfoCss } from '~/components/common/typography'
import { formatBytes } from '~/core/utils'
import { FlexCentered } from '~/components/common/containers'

const Container = styled(FlexCentered)`
  flex-shrink: 0;
`

const BottomText = styled.div`
  ${secondaryInfoCss}
  align-self: flex-end;
`

export default ({ isHovered, fileSizeBytes }) => (
  <Container fullHeight>
    {isHovered
      ? (
        <DownloadIcon />
        )
      : (
        <BottomText>
          {formatBytes(fileSizeBytes, 2)}
        </BottomText>
        )}
  </Container>
)
